import { Platform, StyleSheet } from 'react-native';
import colors from '../../lib/colors';

export const checkoutResultStyles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#f8faf5',
    },
    scrollView: {
        flex: 1,
    },
    resultSection: {
        alignItems: 'center',
        paddingHorizontal: 24,
        paddingVertical: 64,
    },
    card: {
        width: '100%',
        maxWidth: 760,
        alignItems: 'center',
        borderWidth: 1,
        borderColor: '#dfe8d8',
        borderRadius: 28,
        backgroundColor: '#ffffff',
        paddingHorizontal: 32,
        paddingVertical: 44,
        shadowColor: '#1f2937',
        shadowOffset: { width: 0, height: 18 },
        shadowOpacity: 0.08,
        shadowRadius: 30,
        ...(Platform.OS === 'web' ? { boxShadow: '0 24px 80px rgba(31, 41, 55, 0.10)' } : {}),
    },
    iconWrap: {
        width: 72,
        height: 72,
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 2,
        borderRadius: 36,
        marginBottom: 22,
        backgroundColor: '#fbfdf9',
    },
    statusCopy: {
        width: '100%',
        alignItems: 'center',
    },
    eyebrow: {
        color: colors.primaryGreenDark,
        fontSize: 13,
        letterSpacing: 1.2,
        marginBottom: 10,
        textTransform: 'uppercase',
    },
    title: {
        maxWidth: 620,
        color: colors.text900,
        fontSize: 42,
        lineHeight: 48,
        marginBottom: 18,
        textAlign: 'center',
    },
    body: {
        maxWidth: 580,
        color: colors.text600,
        fontSize: 18,
        lineHeight: 28,
        textAlign: 'center',
    },
    finePrint: {
        maxWidth: 520,
        marginTop: 22,
        color: colors.text500,
        fontSize: 13,
        lineHeight: 20,
        textAlign: 'center',
    },
    sessionPill: {
        alignItems: 'center',
        gap: 4,
        marginTop: 28,
        borderWidth: 1,
        borderColor: colors.border,
        borderRadius: 16,
        backgroundColor: colors.bgWeak,
        paddingHorizontal: 18,
        paddingVertical: 12,
    },
    sessionLabel: {
        color: colors.text500,
        fontSize: 12,
        letterSpacing: 0.6,
        textTransform: 'uppercase',
    },
    sessionValue: {
        color: colors.text700,
        fontSize: 14,
    },
    errorText: {
        marginTop: 18,
        color: colors.errorRed,
        fontSize: 14,
        textAlign: 'center',
    },
    actions: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 12,
        marginTop: 34,
    },
    actionButton: {
        minWidth: 170,
    },
    supportText: {
        marginTop: 18,
        color: colors.text500,
        fontSize: 13,
        lineHeight: 20,
        textAlign: 'center',
    },
});
